import React, { FC, useEffect } from 'react';
import { RocheUISubline } from '@repo/roche-ui';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { blokToComponent } from '../../helpers/blok-to-component';
import { DateService } from '@rocheglobal/component-library-dot-com/src/services/date/index';

type RocheSublineProps = BlokToComponentProps<{
  author: string;
  author_description: string;
  attribution_phrase?: string;
  date?: string;
  slotted_avatar: any[];
}>;

export const RocheSubline: FC<RocheSublineProps> = ({ blok, getComponent, slot }) => {
  const [formattedDate, setFormattedDate] = React.useState<string | undefined>(undefined);

  const dateTime = DateService.getDateTimeValue(blok.date);
  const slottedAvatar = blok.slotted_avatar?.map((avatar) =>
    blokToComponent({ getComponent, blok: avatar }, 'subline-avatar'),
  );

  useEffect(() => {
    const formatDate = async () => {
      if (blok.date) {
        const date = await DateService.formatDate(blok.date, 'll');
        setFormattedDate(date);
      }
    };
    formatDate();
  }, [blok.date]);

  return (
    <div slot={slot}>
      <RocheUISubline
        author={blok.author}
        authorDescription={blok.author_description}
        attributionPhrase={blok.attribution_phrase}
        displayDate={formattedDate}
        dateTimeValue={dateTime}
      >
        {slottedAvatar.length ? slottedAvatar : null}
      </RocheUISubline>
    </div>
  );
};
